import React from "react";
import { FaPlusCircle } from "react-icons/fa";
import "./AddCard.css";

const AddCard = ({ title = "Paramètres généraux", onADD }) => {
  return (
    <div className="border rounded-4 shadow-sm p-3 bg-white new-study-card h-100">
      <div className="d-flex flex-column align-items-center h-100">
        <p className="card-title" style={{ color: "#cccccc" }}>
          {title}
        </p>
        <hr
          className="w-100 m-2"
          style={{ color: "rgba(77, 100, 102, 1)" }}
        ></hr>
        <div className="h-100 d-flex justify-content-center align-items-center" onClick={onADD} style={{ cursor: "pointer" }}>
        <FaPlusCircle className="new-study-icon " />
        </div>
      </div>
    </div>
  );
};

export default AddCard;
